import { render, staticRenderFns } from "./SmsTemplateModal.vue?vue&type=template&id=2d1c5fc0&scoped=true"
import script from "./SmsTemplateModal.vue?vue&type=script&lang=js"
export * from "./SmsTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./SmsTemplateModal.vue?vue&type=style&index=0&id=2d1c5fc0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1c5fc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1c5fc0')) {
      api.createRecord('2d1c5fc0', component.options)
    } else {
      api.reload('2d1c5fc0', component.options)
    }
    module.hot.accept("./SmsTemplateModal.vue?vue&type=template&id=2d1c5fc0&scoped=true", function () {
      api.rerender('2d1c5fc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Sms/SmsTemplateModal.vue"
export default component.exports